// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"f29358f2","496":"8d8889c6","647":"11509b75"}[chunkId] + ".chunk.js";
};